// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.songwriter-work-share-update-request-scene {
  min-height: calc(100vh - 210px);
  padding: 0 24px 40px;
}
.songwriter-work-share-update-request-scene .content-header .data-container {
  padding-left: 0;
}
.songwriter-work-share-update-request-scene .description-content p {
  max-width: 900px;
  line-height: 1.45;
}

.share-update-request-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 260px;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/SongwriterScene/SongwriterWorkShareUpdateRequestScene/index.scss"],"names":[],"mappings":"AAAA;EACE,+BAAA;EACA,oBAAA;AACF;AACE;EACE,eAAA;AACJ;AAEE;EACE,gBAAA;EACA,iBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;AADF","sourcesContent":[".songwriter-work-share-update-request-scene {\n  min-height: calc(100vh - 210px);\n  padding: 0 24px 40px;\n\n  .content-header .data-container {\n    padding-left: 0;\n  }\n\n  .description-content p {\n    max-width: 900px;\n    line-height: 1.45;\n  }\n}\n\n.share-update-request-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 260px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
